import { createMemoStyles } from '@wds/utils';

const useMainStyles = createMemoStyles(() => ({
  Main: {
    maxWidth: 1400,
    margin: [0, 'auto'],
  },
  RefreshFullWidth: {
    maxWidth: 1780,
    margin: [0, 'auto'],
  },
}));

export default useMainStyles;
